module.exports = __webpack_public_path__ + "static/media/yoga-girls.f1952ea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/yoga-girls.jpg
// module id = 1120
// module chunks = 0